<kendo-dropdownlist
  [data]="data"
  (valueChange)="onChange($event)"
  [defaultItem]="defaultItem"
  [value]="selectedValue"
  [valuePrimitive]="true"
>
</kendo-dropdownlist>
